module.exports = __webpack_public_path__ + "img/hr-fluid-wagon-shadow-7.c2b18bef.png";